<template>
    <div class="dashboard-no-dashboard h-100">
        <div class="d-flex flex-column align-items-center justify-content-center h-100">
            <img :src="brandNavbarLogo" :alt="brandName" class="imageRotateHorizontal">
        </div>
    </div>
</template>

<script>
    export default {
        name: "DashboardNoDashboard",

        props: {
            screenUid: {
                type: String,
                required: true,
            },
            screen: {
                type: Object,
                required: false,
            },
        },
    }
</script>

<style lang="scss" scoped>
    .dashboard-no-dashboard {
        background-color: #000000;
        .imageRotateHorizontal {
            max-height: 300px;
            max-width: 500px;
        }
    }
</style>
